<template>
  <ApolloQuery
    :query="ImportFilesTilePreviewDataQuery"
    :variables="{...listQueryParams}"
    :fetch-policy="'network-only'"
    class="files-tile-content"
  >
    <template slot-scope="{result: {data}, isLoading}">
      <div
        v-if="isLoading"
        v-loading="isLoading"
        class="file-info-box"
      />

      <el-empty
        v-else-if="getImportFilesList(data).length === 0"
        :description="$t('noDataAvailable')"
      />

      <div
        v-for="importFile in getImportFilesList(data)"
        v-else
        :key="importFile.id"
        class="file-info-box"
      >
        <div class="file-details-box">
          <div class="top-file-details">
            <span class="file-date">
              {{ dateForList(importFile.created_at) }}
            </span>

            <div class="file-packages-count">
              {{ importFile.packages.length }} {{ $t("filesPage.packages").toString().toLowerCase() }}
            </div>

            <div class="file-package-items-count">
              {{ importFile.packages.reduce((acc, currentPackage) => acc + currentPackage.packageItems.length, 0) }} {{ $t("filesPage.packageItems").toString().toLowerCase() }}
            </div>
          </div>

          <div
            v-if="importFile.file"
            class="file-name"
          >
            {{ importFile.file.filename }}
          </div>
        </div>
      </div>
    </template>
  </ApolloQuery>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'

import moment from 'moment'

import {
  SortOrder,
  ImportFilesTilePreviewDataQuery,
  ImportFilesTilePreviewDataQueryVariables,
  ImportFileColumn
} from '@/types/graphql'
import { ApolloQueryResult } from 'apollo-client'

@Component({
  components: {}
})
export default class FilesTable extends Vue {
  // ➊ Props

  // ➋ Data

  private ImportFilesTilePreviewDataQuery = ImportFilesTilePreviewDataQuery

  private listQueryParams: ImportFilesTilePreviewDataQueryVariables = {
    page: 1,
    first: 20,
    orderBy: [
      {
        column: ImportFileColumn.CreatedAt,
        order: SortOrder.Desc
      }
    ]
  }

  // ➌ Computed

  // ➍ Watchers

  // ➎ Hooks

  // ➏ Methods

  private dateForList(date: Date) {
    return moment(date).format('DD/MM/YYYY')
  }

  private getFileExtension(name: String) {
    const fileName = name.trim()

    const extension = fileName.split('.').pop()

    return extension === 'fileName' ? '-' : extension
  }

  private getImportFilesList(data: ApolloQueryResult<ImportFilesTilePreviewDataQuery>['data']) {
    return data?.importFiles?.data || []
  }
}
</script>

<style lang="scss">
.files-tile-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

}

.file-info-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1;
  align-items: center;
  gap: 10px;
  padding: 2px 5px;
  &:nth-child(even) {
    background: hsl(210, 40%, 97%);
  }
  .el-loading-mask {
    background-color: hsla(0, 0%, 0%, 0);
  }
  .file-extension {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    min-width: 25px;
    height: 25px;
    min-height: 25px;
    background-color: hsl(210, 40%, 60%);
    color: hsl(210, 40%, 100%);
    font-size: 8px;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 100%;
  }
  .file-details-box {
    font-size: 9px;
    text-align: left;
    line-height: normal;
    font-weight: bold;
    width: calc(100% - 25px);
    .top-file-details {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      .file-type {
        font-size: 9px;
        height: fit-content;
        padding: 2px 6px;
        border-radius: 10px;
        line-height: normal;
      }
      .file-packages-count {
        font-size: 9px;
        height: fit-content;
        padding: 2px 6px;
        border-radius: 10px;
        line-height: normal;
      }
    }
    .file-name {
        display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      font-weight: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 10px;
    }
  }
}

@media only screen and (max-width: 991px) {
  .file-extension {
    display: none !important;
  }
  .file-details-box {
    width: 100% !important;
  }
}
</style>
